import { getRequestParams } from "../../pages_android/custom_views/insta_custom_views/utils_android/CookieHelper"
import fetchWithTimeout, { getHttpParams, getRequestUrl } from "../../pages_android/custom_views/insta_custom_views/utils_android/UrlHelperAndroid"
import { error, log, onResponse } from "./ApiUtils"

// Рейтинг и достижения исполнителя (на сервере — rating.js)
export class RatingApi {
    static request(name, extra, onSuccess, onError) {
        const params = Object.assign(getRequestParams(), extra || {})
        fetchWithTimeout(getRequestUrl() + "rating/" + name, getHttpParams(params)).then((response) => response.json())
        .then((responseData) => {
            log("rating/" + name + " response = ", responseData)
            onResponse(responseData, onSuccess, onError)
        })
        .catch((e) => {
            log("rating/" + name + " error = ", e)
            error(onError, { response: -1 })
        })
    }
    // Вход за день: { rating, reward (null — сегодня уже начислено), news — непоказанные «чуши» }
    static checkin(onSuccess, onError) {
        RatingApi.request("checkin", null, onSuccess, onError)
    }
    // Экран «Рейтинг»: { rating, achievements, history }
    static get(onSuccess, onError) {
        RatingApi.request("get", null, onSuccess, onError)
    }
    // Окно о «чуши» показано
    static seen(ids, onSuccess, onError) {
        RatingApi.request("seen", { ids: (ids || []).join(",") }, onSuccess || (() => {}), onError || (() => {}))
    }
}
